export default "__VITE_ASSET___PyQQvjA__"